import StatusTabs from './StatusTabs';

export default StatusTabs;
